import React from 'react'
import classes from './Development.module.css'
import { Heading, Image, Grid } from '@chakra-ui/react'

function Development() {
    return (
        <Grid className={classes.container}>
            <Heading>
                Страница в разработке
            </Heading>
            <Image src='/development.png' alt='Development image'/>
        </Grid>
    )
}

export default Development
